import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { Statistics as ST } from '../../features/statistics'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function Statistics(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return <ST id={props.id || ''} />
}
